export default __webpack_public_path__ + "static/media/AfterPhoto9.f0ec44df.jpg";